module.exports = __webpack_public_path__ + "static/media/ItemsLocationIcon.99221531.svg";